import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { WindowContents } from '../enums/windowContents';
import { DQOIService } from '../services/DQOI.service';
import { DQOIDisplaySettings } from '../models/DQOIDisplaySettings';

@Component({
  selector: 'cp-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss']
})
export class WindowComponent implements OnInit {
    constructor(private svc_dqoi: DQOIService, private changeRef: ChangeDetectorRef) {
    }

  ngOnInit() {
      //alert(JSON.stringify(this.childComp) + ' ' + JSON.stringify(this.compData));
      this.setTitle(null);
  }
	//@Input() title: string;
    @Input() childComp: number;
    @Input() compData: any;
	@Output() closed = new EventEmitter<boolean>();
    @Input() isConstruction: boolean = false;
    @Input() dqoiDisplaySettings: DQOIDisplaySettings = null;
	public childTitle: string;
    public contentTypes = WindowContents;

    ngAfterViewInit() {
        this.changeRef.detectChanges();
    }

	setTitle(title){
		this.childTitle = title ? title : ' ';
	}
	
    closeWindow(e?: any) {
        if (this.dqoiIndex !== null) {
            this.svc_dqoi.clearDQOIItem(this.dqoiIndex);
            this.dqoiIndex = null;
        }
		this.closed.emit(true);
    }
    cancelEvent() {
        this.closed.emit(false);
    }
    dqoiIndex: number = null;
    DQOIEvent(index: number) {
        this.dqoiIndex = index;
    }
}
